import axios from "axios";
import TokenService from "./token.service.js";

const baseURL = process.env.REACT_APP_API_URL;

let refreshPromise = null;

/**
 * Single-flight token refresh shared by every axios instance.
 *
 * Concurrent 401s MUST share one refresh call: the backend rotates and
 * blacklists refresh tokens, so two parallel refreshes with the same token
 * mean the second is rejected as blacklisted and the user gets logged out
 * for no reason.
 */
export default function refreshTokens() {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(
        baseURL + "/auth/refresh/",
        { refresh: TokenService.getLocalRefreshToken() },
        { timeout: 15000 }
      )
      .then((rs) => {
        TokenService.updateLocalAccessToken(rs.data.access);
        // Rotation returns a new refresh token. Not storing it meant the next
        // refresh reused a blacklisted token and force-logged the user out
        // every ~30 minutes.
        if (rs.data.refresh) {
          TokenService.updateLocalRefreshToken(rs.data.refresh);
        }
        return rs.data.access;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}
